import React, {useState} from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Modal, Row, Col, ListGroup, Card, Container } from 'react-bootstrap';
import { useQuery } from "react-query";

import {getItemDetailsByLanguageCategorySlug} from '../common/api';

import LoadingComponent from "./LoadingComponent";
import ManageFilePreviewComponent from "./ManageFilePreviewComponent";
import DownloadButtonPartial from "../partials/DownloadButtonPartial";
import ItemsCarouselPartial from "../partials/ItemsCarouselPartial";

import * as functionHelper from '../common/functions';


const ItemDetailsComponent = () => {

  const [previewExtension, setPreviewExtension] = useState(null);
  const [previewId, setPreviewId] = useState(null);
  const [previewHash, setPreviewHash] = useState(null);
  const [activeFile, setActiveFile] = useState(0); 

  const params = useParams();

  const { isLoading, isFetched, data, isError, isFetching } = useQuery(
    {
        queryKey: ['itemDetails', params.category],
        queryFn: () => getItemDetailsByLanguageCategorySlug(params.language, params.category, params.slug),
        enabled: true,
        staleTime: Infinity,
        retry: false
    }
  )

  const changePreviewInfo = (key, item) => {
    
    if(item !== undefined && item.ext !== undefined){
      setPreviewExtension(item.ext)
      setActiveFile(key);
      setPreviewId(item.id);
    }
  }

  if(isLoading || isFetching){
    return <LoadingComponent />
  }

  if(isError){
      return <div>Wystapił bład podczas ładowania treści</div>
  }


  if(
    !isLoading &&
    data.data.data !== undefined && 
    previewId === null && 
    previewExtension === null &&
    previewHash === null &&
    data.data.data.download !== undefined && 
    Object.keys(data.data.data.download).length > 0 && 
    data.data.data.download.files !== undefined && 
    Object.keys(data.data.data.download.files).length > 0
    ){
      if(previewExtension === null){setPreviewExtension(data.data.data.download.files[0].ext)}
      if(previewId === null){setPreviewId(data.data.data.download.files[0].id)};
      if(previewHash === null){setPreviewHash(data.data.data.download.hash)};
  }
  const uniqueSeries = functionHelper.getUniqueSeriesNames(data.data.data.series);

  return(
    <React.Fragment>
     <Container>
     <Row className="mt-4 mb-4">
     <h1>{data.data.data.name}</h1>
     <h3>
     <ul className="list-inline seriesList">
              {
                
                uniqueSeries.map((series, key) => {
                  return (
                    <React.Fragment key={key}>
                      <li className="list-inline-item"><small>{series}</small></li>
                    </React.Fragment>
                  );
                })
              }
            </ul>
      </h3>   
      </Row>    
      
     <Row>
            <Col className='col-sm-12 col-md-4 col-lg-4'>
              <h2 className="text-center">Lista plików do pobrania</h2><hr/>
              <div className="filesListWrapper">
                <ListGroup as="ul" className="filePreview">
                {
                 data.data.data.download.files.map((file, key) => {
                    let activeItem = activeFile === key ? true : false; 
                    return(
                      <ListGroup.Item as="li" key={key} active={activeItem} onClick={() => changePreviewInfo(key, file)}>
                        <strong>{file.name}</strong><br/><small>Format pliku: <strong>{file.ext}</strong>, Rozmiar pliku: <strong>{file.bytes}</strong></small>
                      </ListGroup.Item>
                    );
                  })
                }
                </ListGroup>
              </div>
              
              <hr/>
              <div className="d-grid gap-2"><DownloadButtonPartial item={data.data.data} language={params.language} description={"Pobierz"}/></div>
            

            </Col>
            <Col className='col-sm-12 col-md-8 col-lg-8'>
              <ManageFilePreviewComponent status={data.data.data.download.status} extension={previewExtension} file={previewHash} language={params.language} id={previewId} />
            </Col>
            
           
          </Row>
          <hr/>
          <Row>
            <ItemsCarouselPartial items={data.data.data.similar} language={params.language} />
          </Row>
     </Container>
    </React.Fragment>
  )

}
export default ItemDetailsComponent;